module.exports = __webpack_public_path__ + "img/1.ae1d9732.png";